import { render, staticRenderFns } from "./radio_v.vue?vue&type=template&id=64009996&scoped=true&"
import script from "./radio_v.vue?vue&type=script&lang=js&"
export * from "./radio_v.vue?vue&type=script&lang=js&"
import style0 from "./radio_v.vue?vue&type=style&index=0&id=64009996&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64009996",
  null
  
)

export default component.exports